module.exports = __webpack_public_path__ + "static/img/1-2.08d8b8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-2.jpg
// module id = ejm5
// module chunks = 1